export {
  InstantSearchProvider,
  useInstantSearchClient
} from './InstantSearchProvider'
